import { Model } from '@/models/Model';
export class Year extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'Year';
        this.$endpoint = '/years';
        this.$fillable = ['name', 'starts_at', 'ends_at', 'curriculum', 'lvs_generate_m_test_at', 'lvs_generate_e_test_at'];
    }
    current() {
        return this.filter('current', true).first();
    }
}
